var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBan = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "currentColor",
  fillOpacity: 0.18,
  rx: 4
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "ban_svg__a",
  width: 14,
  height: 14,
  x: 3,
  y: 3,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  x: 3.5,
  y: 3.5,
  fill: "#fff",
  rx: 6.5
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ban_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  x: 3.5,
  y: 3.5,
  fill: "currentColor",
  fillOpacity: 0.3,
  rx: 6.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 4.5,
  y: 4.5,
  stroke: "currentColor",
  strokeOpacity: 0.3,
  strokeWidth: 2,
  rx: 5.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m5 5 10 10"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBan);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMTgiLz4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIzIiB5PSIzIiB3aWR0aD0iMTQiIGhlaWdodD0iMTQiPgogIDxyZWN0IHg9IjMuNSIgeT0iMy41IiB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHJ4PSI2LjUiIGZpbGw9IiNmZmYiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgPHJlY3QgeD0iMy41IiB5PSIzLjUiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgcng9IjYuNSIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMyIvPgogIDxyZWN0IHg9IjQuNSIgeT0iNC41IiB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHJ4PSI1LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMC4zIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBkPSJNNSA1TDE1IDE1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+CjwvZz4KPC9zdmc+Cg==";